import { render } from "./Admin.Tests.WhiteBalance.vue?vue&type=template&id=4a5d183f&scoped=true"
import script from "./Admin.Tests.WhiteBalance.vue?vue&type=script&lang=js"
export * from "./Admin.Tests.WhiteBalance.vue?vue&type=script&lang=js"

import "./Admin.Tests.WhiteBalance.vue?vue&type=style&index=0&id=4a5d183f&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a5d183f"]])

export default __exports__